<ng-template #confirmDialog>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="hideDialog()">
          <span aria-hidden="true">&times;</span>
        </button>
    <h4 class="modal-title">{{ title | translate | uppercase}} </h4>
  </div>
  <div class="modal-body">
    <div class="content">
      {{ message | translate}}
      <ng-content></ng-content>
    </div>
  </div>
  <div class="modal-actions">
    <a [ngClass]="getType()" (click)="accept()">{{'GLOBAL.ACCEPT' | translate | uppercase}}</a>
    <a class="modal-cancel-action" (click)="cancel()">{{'GLOBAL.CANCEL' | translate | uppercase}}</a>
  </div>
</ng-template>